import { Space, Tag, Typography } from "antd";
import { useDraftBailiffRefine } from "hook/draft/bailiff/useDraftBailiffRefine";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const BailiffHeader = () => {
  // -------------------------- VAR -----------------------------
  const data = useDraftBailiffRefine();
  const len = data?.length || 0;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Space style={{ display: "flex", alignItems: "center" }}>
      <Typography.Title style={{ margin: 0 }} level={3}>
        QC Bailiff
      </Typography.Title>
      <Tag style={{ borderRadius: 30 }}>{len} Bailiff</Tag>
    </Space>
  );
};
export default BailiffHeader;
